module.exports = __webpack_public_path__ + "assets/img/tx102a_3.b28c4d17.jpg";